import jSecure from '@linkedin/jsecure';

!(function () {
  function e(e, t) {
    'use strict';
    function r(e) {
      var t = this;
      (this._input = e),
        (this._index = 0),
        (this._last = null),
        (this.next = function () {
          return r.prototype.next.call(t);
        }),
        (this.consume = function () {
          return r.prototype.consume.call(t);
        });
    }
    function n(e) {
      throw new Error(e);
    }
    function a(e) {
      for (
        var t = [],
          r = [],
          a = !1,
          i = [],
          o = new Ie(e),
          s = o.next,
          u = o.consume;
        s();

      )
        if (s() !== Le || o.isEscaped())
          if (o.isEscaped()) i.push(s()), u();
          else {
            if (0 === r.length && s() === Ze) {
              if ((u(), s() === Ze)) {
                i.push(Ze), u();
                continue;
              }
              (a = !a), i.length > 0 && (t.push(i.join(qe)), (i.length = 0));
            }
            a
              ? (s() && i.push(s()), u())
              : s() !== Re || o.isEscaped() || 0 !== r.length
              ? s() === Ue
                ? (0 === r.length
                    ? i.length > 0 && (t.push(i.join(qe)), (i.length = 0))
                    : i.push(s()),
                  r.push(s()),
                  u())
                : s() === Re
                ? (r.pop(),
                  0 === r.length
                    ? i.length > 0
                      ? (t.push({ text: i.join(qe) }), (i.length = 0))
                      : n('Unexpected end of placeholder (found no content)')
                    : i.push(s()),
                  u())
                : (s() && i.push(s()), u())
              : n('Unexpected "}"');
          }
        else u();
      return (
        0 !== r.length && n('Unexpected end of placeholder (unmatched "{")'),
        i.length > 0 && (t.push(i.join(qe)), (i.length = 0)),
        t
      );
    }
    function i(e, t) {
      var r = [],
        a = [];
      if (e() === Ce)
        r.push(e()),
          t(),
          e() &&
            e() !== ze &&
            e() !== Ve &&
            n(
              'Could not parse index; expected ":" or end of identifier but found "' +
                e() +
                '"'
            );
      else if (e() && Xe.test(e()))
        for (; e() && Ye.test(e()); ) r.push(e()), t();
      if (e() === Ve)
        for (
          t(),
            e() && Be.test(e())
              ? (a.push(e()), t())
              : n(
                  'Expected letter (a-zA-Z) or number (0-9) but found "' +
                    e() +
                    '"'
                );
          e() && He.test(e());

        )
          a.push(e()), t();
      else
        0 === r.length &&
          e() &&
          n('Unexpected character; expected ":" but found "' + e() + '"');
      return (
        e() !== ze && e()
          ? n(
              'Unexpected character; expected "," or end of identifier but found "' +
                e() +
                '"'
            )
          : ((r = parseInt(r.join(qe), 10)),
            isNaN(r) && (r = De),
            (a = a.join(qe))),
        { number: r, keyword: a }
      );
    }
    function o(e, t) {
      var r = [];
      if (e()) for (; e() && We.test(e()); ) r.push(e()), t();
      else
        n(
          'Unable to parse type. Expected letter (a-zA-Z) but found end of identifier after ","'
        );
      return r.join(qe);
    }
    function s(e, t, r) {
      for (var a = Qe[r] || Ke, i = [], o = '', s = null, u = void 0; e(); )
        a.test(e()) &&
          (0 === i.length
            ? n(
                'Error parsing style key/value. Found delimiter "' +
                  e() +
                  '" but expected key.'
              )
            : null === s && ((s = i.join(qe)), (i.length = 0), (o = e()), t())),
          i.push(e()),
          t();
      return (
        '' === o
          ? ((s = i.join(qe)), (i.length = 0))
          : ((u = i.join(qe)), (i.length = 0)),
        { key: s, value: u, delimiter: o }
      );
    }
    function u(e, t, r, a) {
      var i = [],
        o = {},
        u = [],
        f = [];
      for (a = a || 0; e(); )
        e() === Ue ? i.push(e()) : e() === Re && i.pop(),
          0 === i.length && e() === Me
            ? (0 === f.length && n('Unexpected "' + Me + '" in style list.'),
              u.push(f.join(qe)),
              (f.length = 0),
              t())
            : (f.push(e()), t());
      return (
        f.length > 0 && (u.push(f.join(qe)), (f.length = 0)),
        u
          .map(function (e) {
            var t = new Ie(e);
            return s(t.next, t.consume, r);
          })
          .forEach(function (e, t) {
            (e.order = t + a),
              o.hasOwnProperty(e.key)
                ? n(
                    'Found duplicate style key "' +
                      e.key +
                      '". Styles must have unique names.'
                  )
                : (o[e.key] = e);
          }),
        o
      );
    }
    function f(e, t) {
      for (var r = [], n = void 0, a = {}; e(); ) r.push(e()), t();
      return (
        (n = r.join(qe)),
        (a[n] = { key: n, value: null, delimiter: null, order: 0 }),
        a
      );
    }
    function l(e, t, r) {
      return Ge[r] ? Ge[r](e, t, r) : u(e, t, r);
    }
    function m(e, t, r) {
      var n = '';
      if ('list' === r) {
        for (var a = []; e() && e() !== ze; ) a.push(e()), t();
        n = a.join(qe);
      }
      return n;
    }
    function d(e, t) {
      var r = null,
        a = null,
        s = '',
        u = {};
      return (
        e()
          ? ((r = i(e, t)),
            e() === ze
              ? (t(),
                (a = o(e, t)),
                e() === ze &&
                  (t(),
                  (s = m(e, t, a)),
                  e() === ze && t(),
                  e() && (u = l(e, t, a))))
              : (a = 'simple'))
          : n('Error parsing placeholder. Unexpected end of input.'),
        e() && n('Unexpected character "' + e() + '".'),
        { index: r, type: a, subtype: s, parameters: u }
      );
    }
    function c(e) {
      var t = new Ie(e);
      return d(t.next, t.consume);
    }
    function p(e) {
      return a(e)
        .map(function (e) {
          return 'string' == typeof e ? e : c(e.text);
        })
        .map(function (e) {
          return 'string' == typeof e
            ? e
            : ('object' == typeof e.parameters &&
                Object.keys(e.parameters).forEach(function (t) {
                  var r = e.parameters[t];
                  r.value && (r.value = p(r.value));
                }),
              e);
        });
    }
    function h(e) {
      this.value = e instanceof h ? v(e) : e;
    }
    function v(e) {
      return e instanceof h ? e.value : e;
    }
    function y(e) {
      return e instanceof h ? e : new h(e);
    }
    function g() {
      return tt;
    }
    function b(e) {
      tt = function (t) {
        if (t instanceof h) return t;
        var r = e(t);
        return new h(r);
      };
    }
    function _(e) {
      return Fe.htmlEncode(e);
    }
    function x(e) {
      console.warn(e);
    }
    function w(e) {
      for (var t = arguments.length, r = [], n = 1; t > n; ++n)
        r.push(arguments[n]);
      return e.replace(/{(\d+)}/g, function (e, t) {
        return 'undefined' != typeof r[t] ? r[t] : e;
      });
    }
    function k(e, t) {
      var r, n;
      for (n = 0, r = e.length; r > n; ++n) {
        var a = e[n];
        if (t.hasOwnProperty(a)) return t[a];
      }
      return null;
    }
    function E(e, t) {
      var r;
      if (e && t)
        for (r in t)
          t.hasOwnProperty(r) && !e.hasOwnProperty(r) && (e[r] = t[r]);
      return e;
    }
    function j(e) {
      nt = e;
    }
    function S(e, t) {
      var r = rt[e];
      return t && r ? r[t] : r;
    }
    function O(e, t) {
      var r = e.parameters[t];
      return r ? r.value : void 0;
    }
    function N(e, t) {
      var r,
        n = e.parameters;
      if (n)
        for (r in n) if (n.hasOwnProperty(r) && n[r].order === t) return n[r];
      return void 0;
    }
    function P(e, t, r, n) {
      var a = O(e, t),
        i = g(),
        o = void 0;
      if ('' === a) return a;
      if (a) {
        var s = a.map(function (e) {
          if (e instanceof Object) {
            var t = nt(e, r, n),
              a = i(t);
            return a;
          }
          return e;
        });
        o = y(
          s.reduce(function (e, t) {
            return e + v(t);
          }, '')
        );
      }
      return o;
    }
    function A(e, t) {
      var r = null;
      if (e && e.index && t) {
        var n = e.index,
          a = n.number,
          i = n.keyword;
        (r = t[a > -1 ? a : 0]),
          (r =
            void 0 !== r && null !== r
              ? 'string' == typeof i && '' !== i
                ? r[i]
                : r
              : void 0);
      }
      return r;
    }
    function F(e) {
      var t = v(e);
      return lt.test(t) ? _(t) : t;
    }
    function T(e, t, r) {
      var n = g(),
        a = A(e, t),
        i = a && 'object' == typeof a,
        o = F(n(i ? a[ot] : a)),
        s = F(i ? n(a[ut]) : null),
        u = F(i ? n(a[ft]) : null),
        f = v(P(e, it, t, r)),
        l = F(P(e, st, t, r)),
        m = {};
      i
        ? Object.keys(a).forEach(function (e) {
            'href' !== e && 'title' !== e && (m[F(n(e))] = F(n(a[e])));
          })
        : (u && (m['class'] = u), s && (m.id = s));
      var d = '<a';
      return (
        o && (d += ' href="' + o + '"'),
        Object.keys(m).forEach(function (e) {
          d += ' ' + e + '="' + m[e] + '"';
        }),
        l && (d += ' title="' + l + '"'),
        (d += '>' + f + '</a>'),
        y(d)
      );
    }
    function $(e, t, r) {
      var n = A(e, t),
        a = '';
      if (n === !0 || n === dt) a = P(e, dt, t, r);
      else {
        if (n !== !1 && n !== ct)
          throw new Error(
            'Invalid argument for BooleanPlaceholder. Expected boolean or "true" or "false" but found "' +
              n +
              '"'
          );
        a = P(e, ct, t, r);
      }
      return a;
    }
    function I(e, t, r) {
      var n,
        a,
        i,
        o,
        s,
        u,
        f = A(e, t),
        l = '',
        m = e.parameters,
        d = yt;
      o = [];
      for (u in m) m.hasOwnProperty(u) && ((s = m[u]), (o[s.order] = s));
      var c = typeof f;
      'number' !== c || isNaN(f)
        ? 'string' === c
          ? ht.test(f)
            ? (d = parseFloat(f))
            : (x(
                "Invalid value for 'choice' placeholder. \"" +
                  f +
                  '" is not a number. Defaulting to 0.'
              ),
              (d = yt))
          : 'object' === c &&
            (d = Array.isArray(f) ? f.length : Object.keys(f).length)
        : (d = f);
      var p = void 0;
      return (
        (n = o.map(function (e, t) {
          var r = {};
          if (vt.test(e.key))
            (r.text = t.toString()),
              (r.comparison = 'eq'),
              (r.category = e.key);
          else {
            switch (((r.text = t.toString()), e.delimiter)) {
              case '<':
                r.comparison = 'gt';
                break;
              case '+':
                r.comparison = 'gte';
                break;
              case '#':
                r.comparison = 'gte';
                break;
              default:
                r.comparison = 'eq';
            }
            (r.arg = parseFloat(e.key)), p || (p = r);
          }
          return r;
        })),
        gt || (gt = new Te.Chooser()),
        (i = gt.format(d, n, r)),
        void 0 !== i
          ? ((a = o[parseInt(i, 10)]), (l = P(e, a.key, t, r)))
          : p && (l = P(e, p.arg, t, r)),
        l
      );
    }
    function U(e, t, r) {
      var n,
        a = A(e, t),
        i = '';
      return (
        void 0 !== a
          ? ((a = a.toString()),
            (n = O(e, a)),
            (i = n ? P(e, a, t, r) : P(e, _t, t, r)))
          : (i = P(e, _t, t, r)),
        i
      );
    }
    function R(e, t) {
      var r = '',
        n = void 0;
      if (void 0 !== e) {
        var a = S(t, 'possessive');
        if (a) {
          var i = void 0;
          if (a.rules)
            for (n in a.rules)
              if (a.rules.hasOwnProperty(n)) {
                var o = a.rules[n],
                  s = new RegExp(n);
                s.test(e) && (i = o);
              }
          void 0 !== i ? (r = i) : a.fallback && (r = a.fallback);
        }
      }
      return r;
    }
    function z(e, t, r) {
      var n = A(e, t),
        a = '';
      return void 0 !== n && (a = R(n, r)), a;
    }
    function V(e, t) {
      var r,
        n = A(e, t);
      return (
        (r =
          void 0 === n
            ? '{' +
              (-1 !== e.index.number ? e.index.number : '') +
              ('' !== e.index.keyword ? ':' + e.index.keyword : '') +
              '}'
            : n),
        g()(r)
      );
    }
    function M(e, t) {
      var r = t instanceof h,
        n = r ? v(t) : t,
        a = n;
      if (e) {
        var i = e[Et],
          o = e[jt];
        i && (a = i.value + a), o && (a += o.value);
      }
      return (a = r ? y(a) : a);
    }
    function C(e, t, r) {
      var n = wt(e, t, r);
      return (n = kt(e.parameters, n));
    }
    function Z(e, t, r) {
      var n = D(parseInt((100 * t).toFixed(1)), r);
      return w(e, n);
    }
    function L(e) {
      return E(E({}, S(e, 'number')), S('default', 'number'));
    }
    function D(e, t) {
      return Ot || (Ot = new Te.NumberFormatter()), Ot.format(e, t);
    }
    function q(e, t) {
      return Ot || (Ot = new Te.NumberFormatter()), Ot.format(Math.floor(e), t);
    }
    function W(e, t, r) {
      return Nt || (Nt = new Te.CurrencyFormatter()), Nt.format(e, t, r);
    }
    function X(e, t) {
      var r = L(t);
      return Z(r.percent, e, t);
    }
    function Y(e, t, r) {
      var n,
        a = A(e, t),
        i = e.parameters;
      return (
        void 0 !== a &&
          (n = i
            ? i.integer
              ? q(a, r)
              : i.currency
              ? W(a, '', r)
              : i.percent
              ? X(a, r)
              : D(a, r)
            : D(a, r)),
        g()(n)
      );
    }
    function B(e, t, r, n) {
      Ft[t] ||
        (Tt[t]
          ? (console.log(
              'The date pattern "' +
                t +
                '" is deprecated, falling back to "' +
                Tt[t] +
                '".'
            ),
            (t = Tt[t]))
          : (console.log(
              'Unknown date pattern "' +
                t +
                '", falling back to "' +
                $t +
                '". Note: custom date patterns are not supported.'
            ),
            (t = $t)));
      var a = Ft[t];
      return At || (At = new Te.DateFormatter()), At.format(e, r, a, n);
    }
    function H(e, t, r) {
      var n = A(e, t),
        a = N(e, 0),
        i = $t;
      return a && (i = a.key), B(n, i, r, !1);
    }
    function K(e, t, r, n) {
      Rt[t] ||
        (zt[t]
          ? (console.log(
              'The time pattern "' +
                t +
                '" is deprecated, falling back to "' +
                zt[t] +
                '".'
            ),
            (t = zt[t]))
          : (console.log(
              'Unknown time pattern "' +
                t +
                '", falling back to "' +
                Vt +
                '". Note: custom time patterns are not supported.'
            ),
            (t = Vt)));
      var a = Rt[t];
      return Ut || (Ut = new Te.TimeFormatter()), Ut.format(e, r, a, n);
    }
    function J(e, t, r) {
      var n = A(e, t),
        a = N(e, 0),
        i = Vt;
      return a && (i = a.key), K(n, i, r, !1);
    }
    function G(e, t, r) {
      var n,
        a,
        i,
        o,
        s,
        u,
        f,
        l,
        m,
        d,
        c = A(e, t),
        p = '',
        h = !1,
        v = e.parameters;
      if (void 0 !== c && (v && (h = !!v[Dt]), (n = S(r, 'suffix'))))
        switch (
          ((m = (n.hardVowels || '') + (n.softVowels || '')), n.strategy)
        ) {
          case qt:
            if (c.length > 0) {
              for (l = c.length - 1, f = l; f >= 0 && u !== Zt && u !== Lt; f--)
                if (((u = c.charAt(f)), -1 !== m.indexOf(u)))
                  return (
                    (d = f === l),
                    (s =
                      n.hardVowels && n.hardVowels.indexOf(u) > -1
                        ? n.hardVowelSuffix
                        : n.fallbackSuffix),
                    (p = '' + (d ? n.bufferChar : '') + s),
                    h ? n.separator + p : p
                  );
              for (a in n.nonVowelToSuffix)
                if (
                  n.nonVowelToSuffix.hasOwnProperty(a) &&
                  ((i = n.nonVowelToSuffix[a]),
                  (o = new RegExp(a)),
                  o.test(c.charAt(l)))
                ) {
                  s = i;
                  break;
                }
              s || (s = n.defaultBufferChar), (p = h ? n.separator + s : s);
              break;
            }
        }
      return p;
    }
    function Q(e, t, r) {
      var n = void 0;
      if (void 0 !== e) {
        var a = {
          firstName: e.givenName || e.firstName,
          lastName: e.familyName || e.lastName,
          maidenName: e.maidenName,
        };
        switch (
          (t || (t = Xt),
          -1 === Yt.indexOf(t) &&
            (console.log(
              'Unrecognized name format "' +
                t +
                '", falling back to "' +
                Xt +
                '".'
            ),
            (t = Xt)),
          t)
        ) {
          case 'given':
            n = a.firstName || '';
            break;
          case 'family':
            n = a.lastName || '';
            break;
          case 'maiden':
            n = a.maidenName || '';
            break;
          default:
            var i =
              'full' === t || 'given' === t || 'family' === t || 'maiden' === t
                ? 'FULL_NAME'
                : 'familiar' === t
                ? 'FAMILIAR_NAME'
                : 'list' === t
                ? 'LIST_VIEW'
                : Wt;
            Bt || (Bt = new Te.NameFormatter()), (n = Bt.format(a, i, r));
        }
      }
      return n;
    }
    function ee(e, t, r) {
      var n = A(e, t),
        a = void 0,
        i = void 0,
        o = k(Yt, e.parameters);
      return (
        (o = o && o.key),
        (a = Q(n, o, r)),
        e.parameters.possessive && (a += R(a, r)),
        (i = g()(a)),
        (a = kt(e.parameters, i))
      );
    }
    function te(e, t, r, n) {
      if (Jt === e) {
        var a = k(Yt, t);
        (a = a && a.key), (r = Q(r, a, n));
      }
      return (r = g()(r)), (r = kt(t, r));
    }
    function re(e, t, r) {
      var n,
        a,
        i,
        o,
        s,
        u = A(e, t),
        f = e.subtype || Gt,
        l = '',
        m = S(r, Qt) || S('default', Qt);
      if (u && u instanceof Array && ((n = u.length), (a = n - 1), n > 0))
        switch (n) {
          case 1:
            l = te(f, e.parameters, u[0], r);
            break;
          case 2:
            l = w(
              m[nr],
              te(f, e.parameters, u[0], r),
              te(f, e.parameters, u[1], r)
            );
            break;
          default:
            (o = 0), (s = 1);
            do
              (i = 0 === o ? er : a > s ? tr : rr),
                (l =
                  i === er
                    ? w(
                        m[i],
                        te(f, e.parameters, u[o], r),
                        te(f, e.parameters, u[s], r)
                      )
                    : w(m[i], l, te(f, e.parameters, u[s], r))),
                o++,
                s++;
            while (i !== rr);
        }
      return l;
    }
    function ne(e) {
      return e
        ? e.index
          ? void 0
          : 'Placeholder must have an index.'
        : 'Placeholder is invalid.';
    }
    function ae(e, t) {
      var r, n, a;
      if (e.parameters) {
        n = e.parameters;
        for (a in n)
          if (n.hasOwnProperty(a) && !t.test(a)) {
            r = 'Invalid style "' + a + '"';
            break;
          }
      }
      return r;
    }
    function ie(e, t) {
      var r, n, a, i, o;
      if (e.parameters)
        for (n = e.parameters, i = 0, o = t.length; o > i; ++i)
          (a = t[i]),
            n.hasOwnProperty(a) ||
              (r = 'Missing required style key "' + a + '"');
      else r = 'Placeholder must have styles';
      return r;
    }
    function oe(e, t, r) {
      var n,
        a,
        i = 'Placeholder must have styles',
        o = 'Placeholder must have exactly ' + t + ' style(s)',
        s = 'Placeholder must have at least ' + t + ' style(s)',
        u = 0;
      if (e.parameters) {
        for (a in e.parameters) e.parameters.hasOwnProperty(a) && u++;
        'eq' === r && u !== t ? (n = o) : 'gte' === r && t > u && (n = s);
      } else t > 0 && (n = i);
      return n;
    }
    function se(e, t) {
      return oe(e, t, 'gte');
    }
    function ue(e, t) {
      return oe(e, t, 'eq');
    }
    function fe(e, t, r) {
      var n, a, i, o;
      if (e.parameters)
        for (a = 0, i = t.length; i > a; ++a)
          (n = e.parameters[t[a]]),
            'without' === r
              ? n && n.value && (o = 'Invalid value for style "' + n.key + '"')
              : 'with' === r &&
                n &&
                (n.value || (o = 'Style "' + n.key + '" must have a value'));
      return o;
    }
    function le(e, t) {
      return fe(e, t, 'with');
    }
    function me(e, t) {
      return fe(e, t, 'without');
    }
    function de(e) {
      var t = ie(e, ur);
      return t || (t = ae(fr)), t;
    }
    function ce(e) {
      var t = se(e, 1);
      return t || (t = ae(e, cr)), t;
    }
    function pe(e) {
      var t,
        r,
        n,
        a,
        i,
        o,
        s,
        u,
        f = e.parameters,
        l = !1;
      o = [];
      for (u in f)
        f.hasOwnProperty(u) &&
          ((s = f[u]), (o[s.order] = s), vr.test(u) && (l = !0));
      for (s = void 0, a = 0, i = o.length; i > a; ++a)
        if (((s = o[a]), hr.test(s.key)))
          if (((n = parseInt(s.key, 10)), void 0 === r)) r = n;
          else {
            if (!(n > r)) {
              t =
                'Invalid number order. Cannot list ' +
                n +
                ' after ' +
                r +
                '. Numbers must be ascending.';
              break;
            }
            r = n;
          }
        else {
          if (!vr.test(s.key)) {
            t = 'Invalid category key "' + s.key + '".';
            break;
          }
          l = !0;
        }
      return (
        l &&
          (f.singular
            ? f.plural || (t = 'Missing required category "plural"')
            : (t = 'Missing required category "singular"')),
        t
      );
    }
    function he(e) {
      var t, r, n, a;
      if (e.parameters) {
        r = e.parameters;
        for (n in r)
          if (r.hasOwnProperty(n) && ((a = !0), !r[n].value)) {
            t = 'MapPlaceholder cannot have keys without values.';
            break;
          }
        a || (t = 'MapPlaceholder must have at least one style argument.');
      } else t = 'MapPlaceholder must have parameters.';
      return t;
    }
    function ve(e) {
      var t = ae(e, wr);
      return t || (t = le(e, xr)), t;
    }
    function ye(e) {
      var t = !1;
      return (
        '' !== e.subtype &&
          (Or.test(e.subtype) ||
            (t = 'Invalid list subtype "' + e.subtype + '"')),
        t || (t = ae(e, Nr)),
        t || (t = le(e, Sr)),
        t
      );
    }
    function ge(e) {
      return ue(e, 0);
    }
    function be(e) {
      var t = ue(e, 1);
      return t || (t = ae(e, Ir)), t || (t = me(e, $r)), t;
    }
    function _e(e) {
      return ae(e, Vr);
    }
    function xe(e) {
      var t, r, n;
      if ('string' != typeof e) {
        if (
          ((n = ar(e)),
          n || (Cr.hasOwnProperty(e.type) && (n = Cr[e.type](e))),
          n)
        )
          throw new Error(n);
        if (e && e.parameters instanceof Object)
          for (t in e.parameters)
            e.parameters.hasOwnProperty(t) &&
              ((r = e.parameters[t]),
              r.value && r.value instanceof Array && r.value.forEach(xe));
      }
    }
    function we(e) {
      return Fe.sanitizeHTML(e);
    }
    function ke(e, t, r) {
      var n = '';
      if (e && t && r) {
        var a = Lr[e.type];
        a && (n = a(e, t, r));
      }
      return n;
    }
    function Ee(e) {
      var t = et(e);
      return t.forEach(Mr), t;
    }
    function je(e, t) {
      return e && 1 === e.length && 'string' == typeof e[0]
        ? function () {
            return Dr(e[0]);
          }
        : function (r) {
            var n = e
              .map(function (e) {
                return 'string' == typeof e ? e : ke(e, r, t);
              })
              .join('');
            return Dr(n);
          };
    }
    function Se(e, t) {
      return je(Ee(e), t);
    }
    function Oe() {
      return g();
    }
    function Ne(e) {
      b(e);
    }
    function Pe() {
      return Dr;
    }
    function Ae(e) {
      Dr = e;
    }
    var Fe = jSecure;
    Fe = 'default' in Fe ? Fe['default'] : Fe;
    var Te = t('t8');
    Te = 'default' in Te ? Te['default'] : Te;
    var $e = '\\';
    (r.prototype.next = function () {
      return this._index < this._input.length ? this._input[this._index] : null;
    }),
      (r.prototype.consume = function () {
        (this._last = this._input[this._index]), this._index++;
      }),
      (r.prototype.isEscaped = function () {
        return this._last === $e;
      }),
      (r.prototype.constructor = r);
    var Ie = r,
      Ue = '{',
      Re = '}',
      ze = ',',
      Ve = ':',
      Me = '|',
      Ce = '0',
      Ze = "'",
      Le = '\\',
      De = -1,
      qe = '',
      We = /[a-zA-Z]/,
      Xe = /[1-9]/,
      Ye = /[0-9]/,
      Be = /[a-zA-Z0-9]/,
      He = /[a-zA-Z0-9_\-~.|\[\]\/]/,
      Ke = /[#]/,
      Je = /[#+<]/,
      Ge = {},
      Qe = {};
    (Qe.choice = Je),
      (Ge.choice = function (e, t, r) {
        return u(e, t, r);
      }),
      (Ge.date = function (e, t, r) {
        return f(e, t, r);
      }),
      (Ge.number = function (e, t, r) {
        return f(e, t, r);
      });
    var et = p;
    (h.prototype.constructor = h),
      (h.prototype.toString = function () {
        var e = '';
        switch (typeof this.value) {
          case 'object':
          case 'function':
            break;
          default:
            e = this.value + '';
        }
        return e;
      });
    var tt = void 0;
    b(_);
    var rt = {
        default: {},
        ar_AE: {
          list: {
            2: '{0} و {1}',
            start: '{0}، {1}',
            middle: '{0}، {1}',
            end: '{0}، و {1}',
          },
          number: { percent: '{0}%' },
        },
        cs_CZ: {
          list: {
            2: '{0} a {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} a {1}',
          },
          number: { percent: '{0}%' },
        },
        da_DK: {
          list: {
            2: '{0} og {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} og {1}',
          },
          number: { percent: '{0}%' },
          possessive: {
            fallback: 's',
            rules: {
              '.*[SsXxZz]$': '’',
              '.*[A-RT-WYÅÆØ]$': 'S',
              '.*[a-rt-wyåæø]$': 's',
            },
          },
        },
        de_DE: {
          list: {
            2: '{0} und {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} und {1}',
          },
          number: { percent: '{0}%' },
          possessive: {
            fallback: 's',
            rules: {
              '.*[SsXxZzß]$': '’',
              '.*[A-RT-WYÄÖÜ]$': 'S',
              '.*[a-rt-wyäöü]$': 's',
            },
          },
        },
        en_US: {
          list: {
            2: '{0} and {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0}, and {1}',
          },
          number: { percent: '{0}%' },
          possessive: {
            fallback: '’s',
            rules: { '.*[Ss]$': '’', '.*[A-RT-Z]$': '’S', '.*[a-rt-z]$': '’s' },
          },
        },
        es_ES: {
          list: {
            2: '{0} y {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} y {1}',
          },
          number: { percent: '{0}%' },
        },
        fr_FR: {
          list: {
            2: '{0} et {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} et {1}',
          },
          number: { percent: '{0} %' },
        },
        in_ID: {
          list: {
            2: '{0}, {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0}, {1}',
          },
          number: { percent: '{0}%' },
        },
        it_IT: {
          list: {
            2: '{0} e {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} e {1}',
          },
          number: { percent: '{0}%' },
        },
        ja_JP: {
          list: {
            2: '{0}、{1}',
            start: '{0}、{1}',
            middle: '{0}、{1}',
            end: '{0}、{1}',
          },
          number: { percent: '{0}%' },
        },
        ko_KR: {
          list: {
            2: '{0} 및 {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} 및 {1}',
          },
          number: { percent: '{0}%' },
        },
        ms_MY: {
          list: {
            2: '{0}, {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0}, {1}',
          },
          number: { percent: '{0}%' },
        },
        nl_NL: {
          list: {
            2: '{0} en {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} en {1}',
          },
          number: { percent: '{0}%' },
        },
        no_NO: {
          list: {
            2: '{0}, {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0}, {1}',
          },
          number: { percent: '{0}%' },
          possessive: {
            fallback: 's',
            rules: {
              '.*[SsXxZz]$': '’',
              '.*[A-RT-WY]$': 'S',
              '.*[a-rt-wy]$': 's',
            },
          },
        },
        pl_PL: {
          list: {
            2: '{0} i {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} i {1}',
          },
          number: { percent: '{0}%' },
        },
        pt_BR: {
          list: {
            2: '{0} e {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} e {1}',
          },
          number: { percent: '{0}%' },
        },
        ro_RO: {
          list: {
            2: '{0} și {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} și {1}',
          },
          number: { percent: '{0}%' },
        },
        ru_RU: {
          list: {
            2: '{0} и {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} и {1}',
          },
          number: { percent: '{0}%' },
        },
        sv_SE: {
          list: {
            2: '{0} och {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} och {1}',
          },
          number: { percent: '{0} %' },
          possessive: {
            fallback: 's',
            rules: {
              '.*[SsXxZz]$': '',
              '.*[A-RT-WYÅÄÖ]$': 'S',
              '.*[a-rt-wyåäö]$': 's',
            },
          },
        },
        th_TH: {
          list: {
            2: '{0}และ{1}',
            start: '{0} {1}',
            middle: '{0} {1}',
            end: '{0} และ{1}',
          },
          number: { percent: '{0}%' },
        },
        tl_PH: {
          list: {
            2: '{0}, {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0}, {1}',
          },
          number: { percent: '{0}%' },
        },
        tr_TR: {
          list: {
            2: '{0} ve {1}',
            start: '{0}, {1}',
            middle: '{0}, {1}',
            end: '{0} ve {1}',
          },
          number: { percent: '% {0}' },
          suffix: {
            strategy: 'reverseSearchForVowel',
            hardVowels: 'aAıIoOuU',
            softVowels: 'eEiİÖöÜü',
            separator: '’',
            bufferChar: 'y',
            defaultBufferChar: 'e',
            hardVowelSuffix: 'a',
            fallbackSuffix: 'e',
            nonVowelToSuffix: {
              '/[BbCcÇçDdFfGgĞğHhiJjKkLlMmNnPpRrSsŞşTtVvWwYyZz]/': 'ye',
              '/[IQq]/': 'ya',
              '/[Xx]/': 'e',
            },
          },
        },
        zh_CN: {
          list: {
            2: '{0}和{1}',
            start: '{0}、{1}',
            middle: '{0}、{1}',
            end: '{0}和{1}',
          },
          number: { percent: '{0}%' },
        },
        zh_TW: {
          list: {
            2: '{0}和{1}',
            start: '{0}、{1}',
            middle: '{0}、{1}',
            end: '{0}和{1}',
          },
          number: { percent: '{0}%' },
        },
      },
      nt = function () {},
      at = T,
      it = 'text',
      ot = 'href',
      st = 'title',
      ut = 'id',
      ft = 'class',
      lt = /['"<>]/,
      mt = $,
      dt = 'true',
      ct = 'false',
      pt = I,
      ht = /-?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/,
      vt = /^(zero|singular|dual|few|many|plural|other)$/,
      yt = 0,
      gt = void 0,
      bt = U,
      _t = 'DEFAULT_TEXT',
      xt = z,
      wt = V,
      kt = M,
      Et = 'prefix',
      jt = 'suffix',
      St = C,
      Ot = void 0,
      Nt = void 0,
      Pt = Y,
      At = void 0,
      Ft = {
        fmt_d: 'd',
        fmt_d_short: 'd.short',
        fmt_d_medium: 'd.medium',
        fmt_d_long: 'd.long',
        fmt_m: 'm',
        fmt_m_short: 'm.short',
        fmt_m_medium: 'm.medium',
        fmt_m_long: 'm.long',
        fmt_y: 'y',
        fmt_y_short: 'y.short',
        fmt_md_medium: 'md.medium',
        fmt_md_long: 'md.long',
        fmt_my_medium: 'my.medium',
        fmt_my_long: 'my.long',
        fmt_mdy_short: 'mdy.short',
        fmt_mdy_medium: 'mdy.medium',
        fmt_mdy_long: 'mdy.long',
        fmt_mdy_hm_short: 'time.short',
        fmt_mdy_hm_long: 'time.long',
        fmt_mdy_iso: 'iso',
        iso: 'iso',
      },
      Tt = {
        short: 'fmt_mdy_short',
        medium: 'fmt_mdy_medium',
        long: 'fmt_mdy_long',
        full: 'fmt_mdy_long',
      },
      $t = (Object.keys(Ft), 'fmt_mdy_medium'),
      It = H,
      Ut = void 0,
      Rt = { fmt_hm: 'hm', fmt_hms: 'hms' },
      zt = {
        short: 'fmt_hm',
        medium: 'fmt_hms',
        long: 'fmt_hms',
        full: 'fmt_hms',
      },
      Vt = (Object.keys(Rt), 'fmt_hms'),
      Mt = J,
      Ct = G,
      Zt = ' ',
      Lt = '	',
      Dt = 'sep',
      qt = 'reverseSearchForVowel',
      Wt = 'FULL_NAME',
      Xt = 'familiar',
      Yt = ['familiar', 'family', 'full', 'given', 'list', 'maiden'],
      Bt = void 0,
      Ht = ee,
      Kt = re,
      Jt = 'name',
      Gt = 'text',
      Qt = 'list',
      er = 'start',
      tr = 'middle',
      rr = 'end',
      nr = '2',
      ar = ne,
      ir = de,
      or = 'text',
      sr = 'title',
      ur = [or],
      fr = new RegExp('^(' + [or, sr].join('|') + ')$'),
      lr = ce,
      mr = 'true',
      dr = 'false',
      cr = new RegExp('^(' + [mr, dr].join('|') + ')$'),
      pr = pe,
      hr = /-?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/,
      vr = /^(zero|singular|dual|few|many|plural|other)$/,
      yr = he,
      gr = ve,
      br = 'prefix',
      _r = 'suffix',
      xr = [br, _r],
      wr =
        /^(familiar|family|full|given|list|maiden|micro|possessive|salutation|prefix|suffix)$/,
      kr = ye,
      Er = 'prefix',
      jr = 'suffix',
      Sr = [Er, jr],
      Or = /^(?:name|text)$/,
      Nr =
        /^(?:familiar|family|full|given|list|maiden|micro|possessive|salutation|prefix|suffix)$/,
      Pr = ge,
      Ar = be,
      Fr = 'sep',
      Tr = 'nosep',
      $r = [Fr, Tr],
      Ir = new RegExp('^(' + [Fr, Tr].join('|') + ')$'),
      Ur = _e,
      Rr = 'prefix',
      zr = 'suffix',
      Vr = new RegExp([zr, Rr].join('|')),
      Mr = xe,
      Cr = {
        anchor: ir,
        boolean: lr,
        choice: pr,
        list: kr,
        map: yr,
        name: gr,
        possessive: Pr,
        suffix: Ar,
        text: Ur,
      },
      Zr = {
        formatDate: B,
        formatName: Q,
        formatNumber: D,
        formatInteger: q,
        formatCurrency: W,
        formatPercent: X,
        formatTime: K,
      },
      Lr = {
        anchor: at,
        boolean: mt,
        choice: pt,
        date: It,
        list: Kt,
        map: bt,
        name: Ht,
        number: Pt,
        possessive: xt,
        simple: wt,
        suffix: Ct,
        text: St,
        time: Mt,
      },
      Dr = we;
    j(ke),
      (e.toAst = Ee),
      (e.makeInterpolator = je),
      (e.fromString = Se),
      (e.getUserDataFilter = Oe),
      (e.setUserDataFilter = Ne),
      (e.getOutputFilter = Pe),
      (e.setOutputFilter = Ae),
      (e.formatters = Zr);
  }
  var t = function (e) {
    return window[e];
  };
  e((window.xmessage = {}), t);
})();
